<script lang="ts">
    const design = {
        width: 400,
        height: 673
    };
    let reverseDprTransform = `scale(1)`;
    window.addEventListener('resize', updateDPR);
    updateDPR();
    const translate = 'translate(0, 0)';
    function updateDPR() {
        const { clientWidth, clientHeight } = document.body;
        const { width, height } = design;
        if (clientWidth / clientHeight < 0.565) reverseDprTransform = `${translate} scale(${clientWidth / width})`;
        else reverseDprTransform = `${translate} scale(${clientHeight / height})`;
    }
</script>

<div style="transform: {reverseDprTransform}; transform-origin: top center;">
    <slot></slot>
</div>
